const GmailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 50"
    width="44"
    height="30"
   style={{ marginRight:"6px"}}
  >
    {/* Background */}
    <rect
      width="48"
      height="48"
      rx="10"
      fill="#F5F5F5"
    />
    {/* Red Part of the "M" */}
    <path
      fill="#EA4335"
      d="M4 12L24 28 44 12V18L24 34 4 18z"
    />
    {/* Yellow Part (Top-Right) */}
    <path
      fill="#FBBC04"
      d="M44 12L44 36 40 34V18z"
    />
    {/* Green Part (Bottom-Left) */}
    <path
      fill="#34A853"
      d="M4 12V36L8 34V18z"
    />
    {/* Blue Part (Bottom Bar of the M) */}
    {/* <path
      fill="#4285F4"
      d="M4 L24 10 40 30H4z" 
      
    /> */}
     
  </svg>
);

export default GmailIcon;
